const CRMDataType = {
  BOOLEAN: 5,
  CHOICELIST: 6,
};

export default CRMDataType;
